import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueMouseParallax from 'vue-mouse-parallax'
import VueScrollTo from 'vue-scrollto'
import VueParticles from 'vue-particles'
import checkView from 'vue-check-view'
import VueScrollReveal from 'vue-scroll-reveal';
import store from './store'
import VTooltip from 'v-tooltip'

import VueAnalytics from 'vue-analytics'

Vue.use(VueScrollReveal, {
  class: 'v-scroll-reveal', // A CSS class applied to elements with the v-scroll-reveal directive; useful for animation overrides.
  duration: 1000, 
  delay: 500, 
  distance: '100px',
  mobile: false,
  opacity: 0,
  viewOffset: {
    top: 100,
  },
  origin: 'top',
});

Vue.use(VueAnalytics, {
  id: 'UA-158788267-1', router
})

Vue.use(checkView)

Vue.use(VueParticles)

Vue.use(VTooltip)


Vue.config.productionTip = false

Vue.use(VueMouseParallax)
Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})


new Vue({
  router :router,
  store,
  render: h => h(App),  
}).$mount('#app')

